/* Game terms in the module's text (Hope, Stress, Very Close...). Each app shows them its own way:
   the site registers its TermLink (tooltip and link to the rules); without a renderer a term is a
   plain word styled as a term. */

import { ReactNode } from 'react';

type TermRenderer = (term: string) => ReactNode;

let renderTerm: TermRenderer = (term) => <span className="dh-term">{term}</span>;

/** Called once by the host app, before rendering anything from the module. */
export function setTermRenderer(renderer: TermRenderer) {
  renderTerm = renderer;
}

export function Term({ children }: { children: string }) {
  return <>{renderTerm(children)}</>;
}
